import { cloneDeep } from '@0x234/common-util';
import { createPinia, getActivePinia } from 'pinia';
import { store } from 'quasar/wrappers';

export default store(() => {
    const pinia = createPinia();
    pinia.use(piniaResettableState);
    pinia.use(piniaPreventHydrateState);
    return pinia;
});

function piniaResettableState({ store }) {
    const initialState = cloneDeep(store.$state);
    store.$reset = () => store.$patch(cloneDeep(initialState));
}

function piniaPreventHydrateState({ store, options }) {
    if (options.preventHydrate) {
        store.preventHydrate = options.preventHydrate;
        return;
    }
    store.preventHydrate = [];
}

export function resetAllStores() {
    const states = Object.keys(getActivePinia()?.state.value);
    for (const state of states) {
        getActivePinia()._s.get(state).$reset();
    }
}
